import { reactive } from 'vue'
import { loginCommonConfig } from './common'
import type { LoginPageConfig } from './types'

export const theme = {
  facebookBlue: '#1A77F2',
  googleBlue: '#239FFB',
  appleDark: '#282828',
  inputBorder: '#D0CAE4',
} as const

export const resources = {
  loginBg: '/images/vowpath/login/login-bg.webp',
  logo: '/images/vowpath/login/roc-logo.png',
  novel: '/images/vowpath/login/roc-novel.png',
  facebookIcon: '/images/vowpath/login/icon-facebook-logo.png',
  googleIcon: '/images/vowpath/login/icon-google-logo.png',
  appleIcon: '/images/vowpath/login/icon-apple-logo.png',
  emailIcon: '/images/vowpath/login/icon-email.png',
  emailCodeIcon: '/images/vowpath/login/icon-email-code.png',
} as const

export const loginConfig: LoginPageConfig = {
  theme,
  resources,
  texts: reactive(loginCommonConfig.texts),
}
